import { base_invitation_link, RegistrationPageListResponse, type InvitationReviewListResponse, type LinkListResponse } from "@/types/invitation";
import request from "@/utils/request";

export const fetchLinkList = async (query: any, page_no: number, page_size: number): Promise<LinkListResponse> => {
    const res = await request.post<LinkListResponse>('/invitation/code/list', { ...query, page_no, page_size });
    return {
        list: (res.list || []).map((item: any) => ({
            link: `${base_invitation_link}${item.invite_code}`, // invite_link = base + invite_code
            code: item.invite_code, // invite_code
            isDefault: item.is_default, // first is default
            spot: item.spot_rebate_rate, // spot_rebate_rate
            futures: item.contract_rebate_rate, // contract_rebate_rate
            alpha: item.alpha,
            linkLocation: item.channel_tag,
            clickCount: item.click_count,
            registrationCount: item.registration_count,
            depositCount: item.deposit_count,
            tradeCount: item.trade_count,
            tradingVolume: item.total_volume,
            rebateAmount: item.total_commission,
            registrationType: item.custom_page_id,
            // remarks: item.remarks,
            remarks: item.custom_name || '-',
        })),
        total: res.total
    };
};

export const modifyInvitationLink = async (query: any) => {
    const res = await request.post('/invitation/code/upsert', { ...query });
    return res;
};

// table List
export const fetchCustomList = async (query: any, page_no: number, page_size: number): Promise<RegistrationPageListResponse> => {
    const res = await request.post<RegistrationPageListResponse>('/page/list', { ...query, page_no, page_size });
    return {
        list: (res.list || []).map((item: any) => ({
            name: item.name,
            isLongTerm: item.is_long_term,
            validity: [item.start_date, item.end_date],
            creationTime: item.created_at,
            isHidden: item.is_hidden,
            profileInfo: item.introduction,
            status: item.status,
            templateId: item.template_id,
            default: item.is_default,
        })),
        total: res.total
    };
};

// fetch templates
export const fetchCustomTemplates = async (query: any): Promise<any> => {
    const res = await request.post<any>('/invitation/code/template/list', { ...query });
    return {
        list: (res.list || []).map((item: any) => ({
            id: item.id,
            name: item.name,
            description: item.description || '-',
            createdAt: item.created_at,
            updatedAt: item.updated_at,
        })),
        total: res.total
    };
};

// create or modify
export const upsertCustomRegistrationPage = async (query: any) => {
    const res = await request.post('/invitation/code/upsert', { ...query });
    return res;
};

export const fetchReviewList = async (query: any, page_no: number, page_size: number): Promise<InvitationReviewListResponse> => {
    const res = await request.post<InvitationReviewListResponse>('/invitation/operation/log', { ...query, page_no, page_size });
    return {
        list: (res.list || []).map((item: any) => ({
            submissionTime: item.created_at,
            customerUID: item.target_id,
            type: item.op_type,
            spot: item.spot_rebate_rate || '-',
            futures: item.contract_rebate_rate || '-',
            alpha: item.alpha || '-',
            status: item.state || '-',
            reason: item.reason || '-',
        })),
        total: res.total
    };
};

export const approveClient = async (data: { user_id: string; }): Promise<any> => {
    return await request.post('/invitation/approve', data);
}